/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';


class CreateAnnouncementController {
    public static $inject = [
        'Announcement',
        'User',
        'toaster',
        '$uibModalInstance',
        'bsLoadingOverlayService',
        '$scope'
    ];

    public announce;
    public selected_office='';
    public checkPermission;
    public btnText = 'Create announcement';

    constructor(private Announcement: any,
                private User: IUserService,
                private toaster: any,
                private $uibModalInstance: any,
                private bsLoadingOverlayService: IBsLoadingService,
                private $scope: ng.IScope) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.announce = {
            category: 'team'
        };

        this.checkPermission = User.hasPermission;
    }

    public sendAnnounce(form: angular.IFormController): void {
        form.$submitted = true;
        if (form.$valid) {
            this.bsLoadingOverlayService.start({referenceId: 'requests_loader'});
            this.announce.published_at = moment().utc();
            this.announce.employee = this.User.getUserId();
            this.Announcement.createAnnounce(this.announce).then(() => {
                this.$scope.$emit('$EL', 'notification_board.make_announcement');
                this.bsLoadingOverlayService.stop({referenceId: 'requests_loader'});
                this.toaster.pop('success', 'Announcement created successfully');
                this.$uibModalInstance.close('cancel');
            }, () => {
                this.toaster.pop('error', 'Server error', 'Announcement could not be created');
            });
        }
    }
}

angular.module('beneple.announcement')
    .controller('CreateAnnouncementController', CreateAnnouncementController);



// WEBPACK FOOTER //
// ./frontend/scripts/announcement/controllers/announcement.create.controller.ts